export var OFFER_STATUS;
(function (OFFER_STATUS) {
    OFFER_STATUS["ACCEPTED"] = "ACCEPTED";
    OFFER_STATUS["REJECTED"] = "REJECTED";
    OFFER_STATUS["NOT_PROCEEDING"] = "NOT_PROCEEDING";
    OFFER_STATUS["PENDING"] = "PENDING";
})(OFFER_STATUS || (OFFER_STATUS = {}));
//# sourceMappingURL=Offers.js.map